import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '../../../common/services/url-builder.service';
import { EmailTemplateModel } from '../models/email-template-model';

@Injectable()
export class EmailTemplateHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService
  ) { }

  getAllEmailTemplates(): Observable<EmailTemplateModel[]> {
    const url = this.urlBuilder.getIdentityServerUrl('admin/email-templates');
    return this.http
      .get<EmailTemplateModel[]>(url).pipe(
        map(templates => templates)
      );
  }

  saveCustomTemplate(template: EmailTemplateModel): Observable<EmailTemplateModel> {
    const url = this.urlBuilder.getIdentityServerUrl('admin/email-templates/save');
    return this.http
      .put<EmailTemplateModel>(url, template);
  }



}
